import React from 'react'
import { useFormContext } from 'react-hook-form'
import useSessionStorage from '../../hooks/useSessionStorage'
import { initialFields, TipoDocumentoParams } from '../../consts'

export default function TipoDocumento({ title, label, required = true }) {
  const {
    register,
    getValues,
    trigger,
    formState: { errors },
  } = useFormContext()

  const [storageData, setStorageData] = useSessionStorage(
    'app_data',
    initialFields
  )

  const handleChange = () => {
    // Revalidar el documento con las reglas del nuevo tipo
    if (getValues('MCCPERSTAG.TOMADOR.Nif')) trigger('MCCPERSTAG.TOMADOR.Nif')
    setStorageData(getValues())
  }

  return (
    <div className="form-field">
      {title && <span>{title}</span>}
      <div className="form-group">
        <label htmlFor="MCCPERSTAG.TOMADOR.TipoDocumento">
          {label || 'Tipo identificador'}
        </label>
        <select
          id="MCCPERSTAG.TOMADOR.TipoDocumento"
          className={`form-control form-select${
            errors.MCCPERSTAG?.TOMADOR?.TipoDocumento ? ' hasError' : ''
          }`}
          {...register('MCCPERSTAG.TOMADOR.TipoDocumento', {
            onChange: handleChange,
            required:
              required === true
                ? 'El tipo de identificador es obligatorio.'
                : false,
          })}
        >
          {TipoDocumentoParams.map((tipo, index) => {
            return (
              <option key={index} value={tipo.cod}>
                {tipo.name}
              </option>
            )
          })}
        </select>
      </div>

      {errors?.MCCPERSTAG?.TOMADOR?.TipoDocumento && (
        <div className="error">
          <p>{errors.MCCPERSTAG.TOMADOR.TipoDocumento.message}</p>
        </div>
      )}
    </div>
  )
}
